import { render, staticRenderFns } from "./DetectInfo.vue?vue&type=template&id=5a2aef8b&scoped=true&"
import script from "./DetectInfo.vue?vue&type=script&lang=js&"
export * from "./DetectInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetectInfo.vue?vue&type=style&index=0&id=5a2aef8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2aef8b",
  null
  
)

export default component.exports